export default "__VITE_ASSET__5897db38__"